import React, { useRef, useState, useEffect } from "react";
import { useParams, useLocation, Link, useNavigate } from "react-router-dom";
import Header from "../components/Header/Header";
import ScrollingBanner from "../components/Header/ScrollingBanner";
import Preloader from "../components/Miscellaneous/Preloader";
import backgroundimage from "../Assets/backgroundimage.png";
import bg1 from "../Assets/bg1.png"
import image from "../Assets/image.png";
import HomeImage from "../Assets/HomeImage.png";
import Box1 from "../Assets/Box1.png";
import Box2 from "../Assets/Box2.png";
import Box3 from "../Assets/Box3.png";
import Box4 from "../Assets/Box4.png";
import portfolioData from "../data/portfolioData.json";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const getResponsivePadding = () => {
	const width = window.innerWidth;
	return width < 768 ? 20 : 60;
};
const paddingInline = getResponsivePadding();
const isMobile = window.innerWidth <= 768;

const ThemeOne = () => {
	const { companyName } = useParams();
	const location = useLocation();

	useEffect(() => {
		requestAnimationFrame(() => {
			setTimeout(() => {
				window.scrollTo({ top: 0, behavior: 'auto' });
			}, 0);
		});
	}, [location.pathname]);

	const scrollRef = useRef(null);
	const navigate = useNavigate();

	const handleScroll = () => {
		scrollRef.current?.scrollIntoView({ behavior: "smooth" });
	};
	const [portfolioItems, setPortfolioItems] = useState([]);

	useEffect(() => {
		setPortfolioItems(portfolioData);
	}, []);

	const [vw, setVw] = useState(
		typeof window !== "undefined" ? window.innerWidth : 1200
	);
	useEffect(() => {
		const onResize = () => setVw(window.innerWidth);
		window.addEventListener("resize", onResize);
		return () => window.removeEventListener("resize", onResize);
	}, []);
	const isMob = vw < 1024;

	const cardData = [
		{
			icon: "/img/caseStudies4.png",
			title: "Enhance customer experience",
			description: "Deliver personalized, safer journeys that build lasting customer loyalty and trust.",
		},
		{
			icon: "/img/caseStudies2.png",
			title: "Revenue  and Leadership",
			description: "Launch innovative services that boost vehicle sales and unlock new revenue streams.",
		},
		{
			icon: "/img/caseStudies3.png",
			title: "Accelerate innovation cycles",
			description: "Empower engineering and quality teams to focus on sustainable and customer-driven innovation."
		},
	];

	const [activeIndex, setActiveIndex] = useState(1);

	const handleMouseEnter = (index) => {
		setActiveIndex(index);
	};

	const clientLogos = [
		"../img/Award1.png",
		"../img/Award2.png",
		"../img/Award3.png",
		"../img/Award4.png",
		"../img/Award5.png",
		"../img/Award6.png",
		"../img/Award7.png"
	];

	const outcomeCards = [
		{
			area: "a",
			style: { backgroundColor: "#88C4A0" },
			content: (
				<>
					<p className="outcomeCardspara1" style={{ color: "#0F6D51", fontSize: isMob ? "32px" : "26px" }}>
						Ravity Platform can help us with after sales and data monetization, as we enter the connected economy.
					</p>
					<p className="outcomeCardspara1" style={{ color: "#0F6D51", marginTop: isMob ? "2rem" : "3rem", fontSize: isMob ? "32px" : "26px" }}>
						- Deputy MD
					</p>
				</>
			),
		},
		{
			area: "b",
			style: { backgroundColor: "#F7C5D9" },
			content: (
				<>
					<div className="stats">
						<div className="statBlock">
							<p className="statNumber" style={{ color: " #F00D69", fontSize: isMob ? "44px" : "36px" }}>1 Million+</p>
							<p className="statLabel" style={{ color: "  #F00D69", fontSize: isMob ? "29px" : "23px" }}>Prediction Daily</p>
						</div>
						<div className="statBlock">
							<p className="statNumber" style={{ marginTop: "32px", color: "  #F00D69", fontSize: isMob ? "44px" : "36px" }}>1 Billion+</p>
							<p className="statLabel" style={{ color: "  #F00D69", fontSize: isMob ? "29px" : "23px" }}>Trips analyzed daily</p>
						</div>
					</div>
				</>
			),
		},
		{
			area: "c",
			content: (
				<div style={{ width: "117%", overflow: "visible" }}>
					<img src="../img/homeTestimonial3.png" alt="Analytics Visual"
						// loading="lazy"
						style={{
							marginTop: "-23px",
							height: isMob ? "260px" : "233px",
							marginLeft: "-25px",
							borderRadius: "12px",
							width: isMob ? "97%" : "385px"
						}}
					/>
				</div>
			),
		},
		{
			area: "d",
			style: { backgroundColor: "#1767F4", },
			content: (
				<>
					<p className="outcomeCardspara1" style={{ color: "#FFFFFF", fontSize: isMob ? "30px" : "26px" }}>
						Their Platform capability to ingest data at scale and provide industry focused insight is amazing.
					</p>
					<p className="outcomeCardspara1" style={{ marginTop: isMob ? "2rem" : "3rem", color: "#FFFFFF", fontSize: isMob ? "30px" : "26px" }}>
						-Quality Head
					</p>
				</>
			),
		},
		{
			area: "e",
			style: { backgroundColor: "#000000", marginTop: isMob ? "0px" : "-75px", },
			content: (
				<>
					<p className="outcomeCardspara1" style={{ color: "#FFFFFF", fontSize: isMob ? "32px" : "26px" }}>
						Using Ravity Platform we could significantly fast track the integration of accessories into Renault SDV vehicles at an appropriate price ( 4 times lower than mobilize cost)
					</p>
					<p className="outcomeCardspara1" style={{ marginTop: isMob ? "2rem" : "3rem", color: "#FFFFFF", fontSize: isMob ? "32px" : "26px" }}>
						-Head of Engineering
					</p>
				</>
			),
		},
		{
			area: "f",
			style: { backgroundColor: "#F9CEAD" },
			content: (
				<>
					<div className="stats">
						<div className="statBlock">
							<p className="statNumber" style={{ color: " #C55500", fontSize: isMob ? "44px" : "36px" }}>1 Million+</p>
							<p className="statLabel" style={{ color: " #C55500", fontSize: isMob ? "29px" : "23px" }}>Prediction Daily</p>
						</div>
						<div className="statBlock">
							<p className="statNumber" style={{ marginTop: "32px", color: " #C55500", fontSize: isMob ? "44px" : "36px" }}>1 Billion+</p>
							<p className="statLabel" style={{ color: " #C55500", fontSize: isMob ? "29px" : "23px" }}>Trips analyzed daily</p>
						</div>
					</div>
				</>
			),
		},
		{
			area: "g",
			content: (
				<div style={{ width: "117%", overflow: "visible" }}>
					<img src="../img/homeTestimonial4.png" alt="Analytics Visual"
						// loading="lazy"
						style={{
							marginTop: "-23px",
							height: "233px",
							marginLeft: "-25px",
							borderRadius: "12px",
							width: isMob ? "95%" : "385px"
						}}
					/>
				</div>
			),
		},
		{
			area: "h",
			style: { backgroundColor: "#AFD7E9", color: "#107B93" },
			content: (
				<>
					<p className="outcomeCardspara1" style={{ color: "#067C97", fontSize: isMob ? "32px" : "26px" }}>
						We selected Ravity because of their existing knowledge and capability around using Telematics data to understand road condition and other use cases.
					</p>
					<p className="outcomeCardspara1" style={{ marginTop: isMob ? "2rem" : "3rem", color: "#067C97", fontSize: isMob ? "32px" : "26px" }}>
						-Quality Head
					</p>
				</>
			),
		},
	];
	const [hoverIndex, setHoverIndex] = useState(null);
	const heightMap = {
		0: "310px",
		1: "238px",
		2: "238px",
		3: "195px",
		4: "335px",
		5: "230px",
		6: "210px",
		7: "230px",
	};

	const footerTopItemStyle = {
		flex: "1",
		minWidth: "250px",
		padding: "30px 20px",
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
	};
	const iconStyle = {
		fontSize: "32px",
		color: "#ED1C6F",
		marginRight: isMob ? "32px" : "15px",
		marginTop: isMob ? "-15px" : "-15px",
		width: isMob ? "60px" : "", height: isMob ? "60px" : ""

	};
	const labelStyle = {
		fontSize: isMob ? "35px" : "15px",
		color: "#ffffff",
		marginBottom: "5px",
		fontWeight: "400",
	};
	const valueStyle = {
		fontWeight: "600",
		fontSize: isMob ? "31px" : "16px",
		color: "#ffffff",
		maxWidth: isMob ? "" : "500px",
	};
	const sectionTitleStyle = {
		fontWeight: "600",
		fontSize: "22px",
		color: "#FFFFFF",
		marginBottom: "20px",
	};
	const itemStyle = {
		marginBottom: "12px",
		fontSize: "12px",
	};
	const itemLinkStyle = {
		color: "#fff",
		textDecoration: "none",
		fontSize: isMob ? "32px" : "16px",
		fontWeight: "400",
	};
	const linkHeadingStyle = {
		color: "#fff",
		textDecoration: "none",
		fontWeight: "600",
		fontSize: isMob ? "35px" : "22px"
	};

	return (
		<>
			<Preloader />
			{/* <LenisScroll /> */}
			<ScrollingBanner />
			<Header />
			<section id="home" className=""
				style={{ paddingInline: "0px", paddingBlock: "0px", backgroundColor: "#ffffff", marginTop: isMob ? "359px" : "190px", marginBottom: isMob ? "339px" : "0px" }}>
				<div className="headerWd"
					style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "0px", padding: isMob ? "0" : "0 20px", }}>
					<div style={{ position: "relative", textAlign: "center", width: "100%", maxWidth: isMob ? "100%" : "960px", }}>
						<div style={{
							backgroundImage: `url(${bg1})`, backgroundSize: "cover", backgroundPosition: "center", borderRadius: "30px", padding: "28px 10px 100px",
							position: "relative", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: isMob ? "1250px" : ""
						}}>
							<h1 style={{ fontSize: isMob ? "90px" : "clamp(32px, 8vw, 80px)", fontWeight: 700, marginTop: "-2rem", lineHeight: 1.2, color: "#000000", textAlign: "center", padding: "0 20px", maxWidth: "100%", marginBottom: isMob ? "123px" : "", }}>
								The AI Revolution for
								Mobility Intelligence
							</h1>
							<img src={HomeImage} alt="AI Mobility"
								style={{ width: "100%", maxWidth: isMob ? "750px" : "700px", height: isMob ? "700px" : "auto", borderRadius: "20px", position: "relative", zIndex: 1, }}
							/>
							<img src={Box1} alt="Box1"
								style={{ position: "absolute", top: "clamp(120px, 18vw, 180px)", left: "clamp(10px, 4vw, 40px)", zIndex: 3, width: isMob ? "300px" : "clamp(120px, 18vw, 180px)", height: isMob ? "300px" : "auto", marginTop: isMob ? "150px" : "0px", }}
							/>
							<img src={Box2} alt="Box2"
								style={{ position: "absolute", top: "clamp(130px, 19vw, 198px)", right: "clamp(10px, 4vw, 40px)", width: isMob ? "280px" : "clamp(120px, 18vw, 180px)", zIndex: 3, marginTop: isMob ? "230px" : "", height: isMob ? "170px" : "", }}
							/>
							<img src={Box4} alt="Box3"
								style={{ position: "absolute", bottom: "clamp(40px, 7vw, 70px)", left: "clamp(10px, 4vw, 40px)", width: isMob ? "260px" : "clamp(100px, 15vw, 150px)", zIndex: 3, height: isMob ? "230px" : "", marginBottom: isMob ? "30px" : "", }}
							/>
							<img src={Box3} alt="Box4"
								style={{ position: "absolute", bottom: "clamp(35px, 6vw, 60px)", right: "clamp(10px, 4vw, 40px)", width: isMob ? "280px" : "clamp(130px, 19vw, 190px)", zIndex: 3, height: isMob ? "250px" : "" }}
							/>
						</div>
					</div>
				</div>
			</section>

			{/* cards section */}
			<section className="mobilitysec bg-white" style={{ paddingInline: isMob ? `30px` : `${paddingInline}px`, margin: isMob ? "130px 0px 195px" : "50px 0px 45px" }}>
				{/* Heading */}
				<div className="headerWd" style={{ textAlign: "center", marginBottom: "50px" }}>
					<h2 style={{ fontSize: isMob ? "72px" : "42px", fontWeight: "700", marginBottom: isMob ? "180px" : "78px", }}>
						Drive Impact with Mobility Intelligence
					</h2>
				</div>

				{/* Cards */}
				<div className="headerWd responsive-card-grid"
					style={{ display: "grid", gap: "20px", width: "100%", maxWidth: "1400px", boxSizing: "border-box", }}
				>
					{cardData.map((card, i) => (
						<div key={i} className="impact-card"
							style={{ padding: "24px", borderRadius: "12px", background: "#F2F2F2", textAlign: "left", display: "flex", flexDirection: "column", boxShadow: "0px 4px 4px 0px #00000040", marginBottom: isMobile ? "0px" : "50px" }}
						>
							<img src={card.icon} alt={card.title} style={{ width: "100%", height: "auto", borderRadius: "14px", marginBottom: "25px", }} />
							<div style={{ flexGrow: 1, marginBottom: isMob ? "30px" : "0px" }}>
								<h4 className="impact-title">{card.title}</h4>
								<p className="impact-desc">{card.description}</p>
							</div>
						</div>
					))}
				</div>

				{/* Responsive Styles */}
				<style>
					{`       
      .responsive-card-grid {         
        grid-template-columns: repeat(3, 1fr);       
      }        

      /* Base font sizes (desktop default) */
      .impact-title {
        font-size: 22px;
        font-weight: 600;
        color: #000;
        margin-bottom: 20px;
        line-height: 120%;
      }

      .impact-desc {
        font-size: 18px;
        font-weight: 400;
        color: #000;
        line-height: 150%;
        letter-spacing: -0.022em;
      }

      /* Tablet screens and below */
      @media (max-width: 1023px) {         
        .responsive-card-grid {           
          grid-template-columns: 1fr !important;         
        }     

        .impact-title {           
          font-size: 62px;
		  margin-bottom: 50px;
        }          

        .impact-desc {           
          font-size: 51px;
		  margin-bottom: 50px;
        }     
      }        

      /* Mobile screens */
      @media (max-width: 767px) {         
        .responsive-card-grid {           
          grid-template-columns: 1fr !important;         
        }          

        .impact-title {           
          font-size: 26px;   /* bigger for clarity */    
        }          

        .impact-desc {           
          font-size: 20px;   /* bigger for clarity */    
        }          

        .impact-card {           
          height: auto;         
        }       
      }        

      /* Smallest phones */
      @media (max-width: 480px) {
  .impact-title {
    font-size: 50px !important;
  }

  .impact-desc {
    font-size: 22px !important;
  }
}

    `}
				</style>
			</section>

			{/*  */}
			<section className="mobilitysec bg-white" style={{ paddingInline: isMob ? `30px` : `${paddingInline}px`, margin: isMob ? "100px 0" : "70px 0", }}>
				<div className="headerWd">
					<h2 className="mobilityh4" style={{ fontSize: isMob ? "48px" : "42px", marginBottom: isMob ? "230px" : "" }}>Meet your AI-Powered Mobility Workforce</h2>
					<p className="mobilitypara" style={{ display: isMob ? "none" : "" }}>
						SAGE AI intelligence combined with specialized Agents of Mobility that
						transform every department.
					</p>
					<div className="row" style={{ "--bs-gutter-x": "0rem", marginTop: "70px" }}>
						<div className="stack-wrapper" style={{ gridRowGap: isMob ? "245px" : "40px" }}>
							{portfolioItems.map((item) => (
								<div className="stack-item" key={item.id}>
									<div className="card portfolio-item layout-2 scale has-shadow"
										style={{ height: isMob ? "1080px" : "650px", marginBottom: "30px", position: "relative", }}
									>
										<div className="image-holder">
											<img src={item.image} alt={item.title}
												style={{ width: "100%", height: isMob ? "720px" : "100%", borderRadius: "!2px", }}
											/>
											<div className="card-overlay"
												style={{ position: "absolute", bottom: "2%", left: "2%", width: "100%", color: item.id === 2 || item.id === 4 ? "#000" : "#fff", padding: "20px", boxSizing: "border-box", display: "flex", flexDirection: "column", gap: "12px", }}>
												<h4 className="title"
													style={{ marginBottom: isMob ? "-16px" : "5px", fontSize: isMob ? "45px" : "40px", fontWeight: "600", lineHeight: "150%", letterSpacing: "-2.2%", color: item.id === 2 || item.id === 4 ? "#000" : "#fff", }}>
													{item.title}
												</h4>
												<p className="subtitle"
													style={{fontSize: "32px", display: isMob ? "none" : "",fontWeight: "500",lineHeight: "10%",letterSpacing: "-2.2%",marginBottom: "14px",color: item.id === 2 || item.id === 4 ? "#000" : "#fff",}}>
													{item.subtitle}
												</p>

												{item.buttonText && item.buttonLink && (
													<a href={item.buttonLink}
														style={{
															backgroundColor: "transparent",
															color: item.id === 2 || item.id === 4 ? "#000" : "#fff",
															padding: "12px 20px",
															borderRadius: "25px",
															textDecoration: "none",
															fontWeight: "400",
															border: `1px solid ${item.id === 2 || item.id === 4 ? "#000" : "#fff"}`,
															width: isMob ? "195px" : "160px",
															height: isMob ? "64px" : "52px",
															display: "flex",
															alignItems: "center",
															justifyContent: "center",
															marginTop: "20px",
															fontSize: isMob ? "25px" : "16px",
															gap: "9px",
														}}
													>
														{item.buttonText.split("→")[0]}
														<span style={{ fontSize: isMob ? "25px" : "18px" }}>→</span>
													</a>
												)}
											</div>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</div>

				{/* Responsive Styles */}
				<style>
					{`
      /* Default desktop */
      .mobilitypara {
        font-size: 18px;
        font-weight: 400;
        color: #000;
        line-height: 150%;
        max-width: 900px;
        margin: 0 auto;
        text-align: center;
      }

      /* Tablet */
      @media (max-width: 1023px) {
        .mobilitypara {
          font-size: 22px;
          line-height: 160%;
        }
      }

      /* Mobile */
      @media (max-width: 767px) {
        .mobilitypara {
          font-size: 26px;
          line-height: 165%;
        }
      }

      /* Smallest phones */
      @media (max-width: 480px) {
        .mobilitypara {
          font-size: 28px !important;  /* force bigger size */
          line-height: 170%;
        }
      }
    `}
				</style>
			</section>

			{/* animation section */}
			< section className="awards animationsec"
				style={{
					marginTop: isMob ? "430px" : "50px", height: isMob ? "1200px" : "",
					paddingInline: `${paddingInline}px`,
					backgroundImage: `url(${backgroundimage})`,
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
					position: "relative",
					padding: "60px 0",
					color: "#fff", marginBottom: isMob ? "100px" : "0px"
				}}>
				<div className="headerWd" style={{ textAlign: "center" }}>
					<h2 className="animationh2" style={{ marginBottom: "40px", fontSize: isMob ? "55px" : "48px" }}>
						Solution that delivers measurable Business Impact
					</h2>
					<div style={{ display: "flex", justifyContent: "center", marginTop: isMob ? "130px" : "" }}>
						<video
							width="100%"
							height="auto"
							// controls
							autoPlay
							muted
							loop
							playsInline
							loading="lazy"
							preload="none"
							style={{borderRadius: "10px",display: "block",maxWidth: isMob ? "92%" : "80%"}}
						>
							<source src="/videos/homeScreen1.mp4" type="video/mp4" />
							Your browser does not support the video tag.
						</video>
					</div>
				</div>
				{/* Learn More Button */}
				<div style={{ display: "flex", justifyContent: "center", marginTop: isMob ? "100px" : "40px" }}>
					<button onClick={() => navigate("/solution/vehicle-engineering")}
						style={{backgroundColor: "#000",color: "#fff",padding: "12px 24px",border: "none",borderRadius: "4px",cursor: "pointer",fontSize: isMob ? "25px" : "16px",}}
					>
						Learn more
					</button>
				</div>
			</section >

			<section className="outcomesec mt-5 mb-4" style={{ paddingInline: isMob ? `30px` : `${paddingInline}px`, }}>
				<div className="headerWd">
					<h2 className="outcomeh2" style={{marginTop: isMob ? "100px" : "", marginBottom: isMob ? "175px" :"90px", fontSize: isMob ? "59px" : "55px"}}>
						Your Success, Powered by Mobility <br /> Intelligence
					</h2>

					{/* First 2 Rows: a to e */}
					<div className="outcomedev">
						{outcomeCards.slice(0, 5).map((card, index) => {
							const isSmallScreen = vw < 1024;
							let height = heightMap[index];
							if (isSmallScreen) {
								if (index === 1) height = heightMap[0];
								if (index === 2) height = heightMap[3];
							}
							const isLastOfFirstBlock = card.area === "e";
							return (
								<div
									key={index}
									className={`outcomedev1 ${isLastOfFirstBlock ? "outcomedev1--tall" : ""}`}
									style={{
										gridArea: card.area,
										height: height || "auto",
										...(hoverIndex === index ? { transform: "scale(1.05)" } : {}),
										...card.style,
									}}
									onMouseEnter={() => setHoverIndex(index)}
									onMouseLeave={() => setHoverIndex(null)}
								>
									{card.content}
								</div>
							);
						})}
					</div>

					{/* Third Row: f, g, h */}
					<div className="outcomesRowThree">
						{outcomeCards.slice(5, 8).map((card, index) => (
							<div
								key={index + 5}
								className="outcomedev1"
								style={{
									gridArea: card.area,
									height: heightMap[index + 5] || "auto",
									...(card.area === "h" ? { gridRow: "span 2" } : {}),
									...(hoverIndex === index + 5 ? { transform: "scale(1.05)" } : {}),
									...card.style,
								}}
								onMouseEnter={() => setHoverIndex(index + 5)}
								onMouseLeave={() => setHoverIndex(null)}
							>
								{card.content}
							</div>
						))}
					</div>
				</div>
			</section>

			{/* Awards section */}
			< section className="outcomesec">
				<div className="marquee headerWd" style={{ height: isMob ? "1000px" : "700px" }}>
					<h1 style={{fontWeight: 600, marginTop: isMob ? "100px" : "-20px", marginBottom: isMob ? "280px" : "160px",
						fontSize: isMob ? "80px" : "48px",lineHeight: '100%',letterSpacing: '0%',textAlign: 'center'}}>
						Awards & Recognition
					</h1>

					<ul className="list-unstyled">
						{clientLogos.map((logo, index) => (
							<li key={index} className="item" style={{ width: isMob ? "330px" : "230px", height: isMob ? "330px" : "230px" }}>
								<a href="/" className="marquee-item rounded">
									<div className="marquee-content" style={{ width: isMob ? "430px" : "150px", height: isMob ? "530px" : "150px" }}>
										<img src={logo} alt={`Brand ${index + 1}`} />
									</div>
								</a>
							</li>
						))}
						{/* Duplicate items for seamless marquee effect */}
						{clientLogos.map((logo, index) => (
							<li key={`duplicate-${index}`} className="item">
								<a href="/" className="marquee-item rounded">
									<div className="marquee-content">
										<img src={logo} alt={`Brand ${index + 1}`} />
									</div>
								</a>
							</li>
						))}
					</ul>
				</div>
			</section >

			{/* demo section */}
			< section className="outcomesec" style={{ paddingInline: isMob ? `30px` : `${paddingInline}px`, margin: isMob ? "255px 0 110px" : "15px 0 65px" }}>
				<div className="awards sticky primary-bg demosec" style={{ height: isMob ? "1000px" : "593px" }}>
					<div className="demodev">
						<h2 className="demoh2" style={{ fontSize: isMob ? "42px" : "30px" }}>Ready to Deploy Your AI Workforce?</h2>
						<p className="demopara" style={{ fontSize: isMob ? "49px" : "40px" }}>
							Experience how Ravity's AI agents can <br /> transform your mobility operations.
						</p>
						<button className="demobtn"
							onClick={() => navigate('/request-demo')} style={{
								width: isMob ? "210px" : "150px", fontSize: isMob ? "26px" : "16px", padding: isMobile ? "30px 0 30px" : "", padding: isMob ? "2rem 1.2rem" : "0.5rem 1rem"
							}}
						>
							<strong>Request Demo</strong>
						</button>
					</div>
				</div>
			</section >

			{/* footer */}
			<footer style={{ backgroundColor: "#0D0F2B", color: "#fff" }}>
				{/* Footer Navigation */}
				<div style={{padding: isMobile ? "30px 20px" : "50px 60px",display: "flex",flexWrap: "wrap",gap: "40px", justifyContent: isMobile ? "flex-start" : "space-between",}}>
					{footerColumns.map((section) => (
						<div key={section.title} style={{minWidth: isMob ? "400px" : "160px",flex: isMobile ? "1 1 100%" : "1 1 180px",}}>
							<div style={sectionTitleStyle}>
								<Link to={section.link} style={linkHeadingStyle}>
									{section.title}
								</Link>
							</div>
							{section.items.map((item, idx) => (
								<div key={idx} style={itemStyle}>
									<Link to={item.link} style={itemLinkStyle}>
										{item.label}
									</Link>
								</div>
							))}
						</div>
					))}
				</div>

				{/* Footer Contact Info and Map Layout */}
				<div style={{display: "flex",padding: isMobile ? "30px 20px" : "10px 60px 30px",flexWrap: "wrap",justifyContent: "space-between",}}>
					{/* Google Map Location */}
					<div style={{ flex: "1", minWidth: isMobile ? "100%" : "500px" }}>
						<iframe
							src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3889.0533436310207!2d77.64800087489175!3d12.904291487404912!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15002922c9d1%3A0xb039aed5ec9a19c!2sRavity%20Software%20Solutions%20Private%20Limited!5e0!3m2!1sen!2sin!4v1752026960132!5m2!1sen!2sin"
							width="100%"
							height="450"
							style={{ border: 0, borderRadius: "12px", height: isMob ? "600" : "450" }}
							allowFullScreen=""
							loading="lazy"
							referrerPolicy="no-referrer-when-downgrade"
							title="Ravity Office Location"
						></iframe>
					</div>

					{/* Contact Info Section */}
					<div style={{flex: "1",minWidth: isMobile ? "100%" : "400px",paddingLeft: isMob ? "0" : "40px",}}>
						{/* Office Location - India */}
						<div style={footerTopItemStyle}>
							<img src="../img/locationIcon.png" alt="Location Icon" style={iconStyle} />
							<div>
								<div style={labelStyle}>Our Office - India</div>
								<div style={valueStyle}>
									4th floor, SV Arcade Building, 1321, 27th Main Rd, near Coal Spark, PWD Quarters, Sector 2, HSR Layout, Bengaluru, Karnataka 560102
								</div>
							</div>
						</div>

						{/* Office Location - UK */}
						<div style={footerTopItemStyle}>
							<img src="../img/locationIcon.png" alt="Location Icon" style={iconStyle} />
							<div>
								<div style={labelStyle}>Our Office - UK</div>
								<div style={valueStyle}>15 Beechcroft Gardens, Wembley, UK HA98ER</div>
							</div>
						</div>

						{/* Write to Us */}
						<div style={footerTopItemStyle}>
							<img src="../img/emailIcon.png" alt="Email Icon" style={iconStyle} />
							<div>
								<div style={labelStyle}>Write to Us</div>
								<div style={valueStyle}>sales@ravity.io</div>
							</div>
						</div>

						{/* Phone Numbers */}
						<div style={{display: "flex", flexWrap: "wrap",justifyContent: isMobile ? "flex-start" : "space-between"}}>
							<div style={footerTopItemStyle}>
								<img src="../img/phoneIcon.png" alt="Phone Icon" style={iconStyle} />
								<div>
									<div style={labelStyle}>Call Us (India)</div>
									<div style={valueStyle}>+91 7267913923</div>
								</div>
							</div>
							<div style={footerTopItemStyle}>
								<img src="../img/phoneIcon.png" alt="Phone Icon" style={iconStyle} />
								<div>
									<div style={labelStyle}>Call Us (UK)</div>
									<div style={valueStyle}>+44 7776244931</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Footer Bottom */}
				{/* Divider */}
				<div style={{width: "95%",height: "1px",backgroundColor: "rgba(255,255,255,0.2)",margin: "20px auto",}}/>
				<div style={{padding: isMobile ? "0px 20px 30px" : "0px 60px 30px",display: "flex",justifyContent: "space-between",alignItems: "center",flexWrap: "wrap",}}>
					<div style={{ color: "#aaa", fontSize: isMob ? "32px" : "14px", marginBottom: isMob ? "0px" : "0px" }}>© 2022 Ravity
						<Link to="/privacy-policy"
							style={{color: "#aaa",textDecoration: "underline",marginLeft: "20px",fontSize: isMob ? "32px" : "14px",}}>
							Privacy Policy
						</Link>
					</div>
					<img src="../img/RavityLogo.png" alt="Logo" style={{ width: isMob ? "80px" : "40px", height: isMob ? "80px" : "40px" }} />
				</div>
			</footer>
		</>
	);
};

export default ThemeOne;

const footerColumns = [
	{
		title: "Products",
		items: [
			{ label: "Quality Intelligence", link: "/product/quality-intelligence" },
			{ label: "Engineering Acceleration", link: "/product/engineering-acceleration" },
			{ label: "Fleet Optimization", link: "/product/fleet-optimization" },
			{ label: "Data Monetization", link: "/product/data-monetization" },
			{ label: "Customer Experience", link: "/product/customer-experience" },
			{ label: "Compliance & Sustainability", link: "/product/compliance-and-sustainability" },
		],
	},
	{
		title: "Solutions",
		items: [
			{ label: "Vehicle Engineering", link: "/solution/vehicle-engineering" },
			{ label: "Sales & Marketing", link: "/solution/sales-and-marketing" },
			{ label: "After Sales & Customer Experience", link: "/solution/after-sales-and-customer-service" },
			{ label: "Fleet Management", link: "/solution/fleet-management" },
			{ label: "Quality", link: "/solution/quality" },
			{ label: "Regulatory & Sustainability", link: "/solution/regulatory-and-sustainability" },
		],
	},
	{
		title: "Platforms",
		items: [
			{ label: "Connected Mobility", link: "/platform/connected-mobility" },
			{ label: "Sage AI", link: "/platform/sage-ai" },
			{ label: "Agents of Mobility", link: "/platform/agents-of-mobility" },
		],
	},
	{
		title: "Customers",
		items: [{ label: "Case Study", link: "/customers" }],
	},
	{
		title: "Company",
		items: [
			{ label: "About Us", link: "/company/about-us" },
			{ label: "Join Our Team", link: "/company/join-Our-team" },
		],
	},
];